import { useEffect, useRef } from 'react';

export function useInfiniteScroll({
  hasMore,
  enabled = true,
  isLoadingMore,
  onLoadMore,
  rootMargin = '120px',
}) {
  const containerRef = useRef(null);
  const sentinelRef = useRef(null);
  const isLoadingMoreRef = useRef(false);

  useEffect(() => {
    isLoadingMoreRef.current = isLoadingMore;
  }, [isLoadingMore]);

  useEffect(() => {
    if (!enabled || !hasMore) return undefined;

    const scrollRoot = containerRef.current;
    const sentinel = sentinelRef.current;
    if (!scrollRoot || !sentinel) return undefined;

    const observer = new IntersectionObserver(
      entries => {
        if (!entries[0].isIntersecting || isLoadingMoreRef.current) return;
        isLoadingMoreRef.current = true;
        onLoadMore();
      },
      { root: scrollRoot, rootMargin },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [enabled, hasMore, rootMargin, onLoadMore, isLoadingMore]);

  return { containerRef, sentinelRef };
}
